import { render } from "./ItemCheckbox.vue?vue&type=template&id=1d07c702"
import script from "./ItemCheckbox.vue?vue&type=script&lang=js"
export * from "./ItemCheckbox.vue?vue&type=script&lang=js"

import "./ItemCheckbox.vue?vue&type=style&index=0&id=1d07c702&lang=scss"

import exportComponent from "/Users/jburnett/Documents/TBA/hockey-scheduler/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__